export const ERROR_MESSAGES = "This field is required.";
export const Title = "Techno Land Engineers and Surveryours";
